import React from "react";
import { Routes, Route } from "react-router-dom";
import CoordinatorHome from "../main/body/screens/Coordinator/CoordinatorHome";
import MedicalEmergencyHistory from "../main/body/screens/EMS/MedicalEmergencyHistory/MedicalEmergencyHistory";
import FlightsScreen from "../main/body/screens/FlightsScreen/FlightsScreen";
import HomeScreen from "../main/body/screens/HomeScreen/HomeScreen";
import IAM from "../main/body/screens/IAM/IAM";
import CreateRole from "../main/body/screens/IAM/Roles/CreateRole/CreateRole";
import Roles from "../main/body/screens/IAM/Roles/Roles";
import Organization from "../main/body/screens/IAM/Organization/Organization";
import AddSubscription from "../main/body/screens/IAM/Organization/AddSubscription";
import ViewSubscription from "../main/body/screens/IAM/Organization/ViewSubscription";
import CreateUsers from "../main/body/screens/IAM/Users/CreateUser/CreateUser";
import Users from "../main/body/screens/IAM/Users/Users";
import ResetPassword from "../main/body/screens/IAM/ResetPassword/ResetPassword";
import Profile from "../main/body/screens/IAM/Users/Profile/Profile";
import MedicalEmergenciesMainScreen from "../main/body/screens/MedicalEmergenciesMainScreen/MedicalEmergenciesMainScreen";
import MedicalEmergencyDetails from "../main/body/screens/MedicalEmergenciesMainScreen/MedicalEmergencyDetails/MedicalEmergencyDetails";
import MedicalEmergencyListScreen from "../main/body/screens/MedicalEmergenciesMainScreen/MedicalEmergencyListScreen/MedicalEmergencyListScreen";
import Conference from "../main/body/screens/MedicalEmergenciesMainScreen/video/Conference";
import AudioConference from "../main/body/screens/MedicalEmergenciesMainScreen/audio/AudioConference";
import LoadingScreen from "../main/loading-screen/LoadingScreen";
import CreateFlight from "../main/body/screens/IAM/Users/CreateFlight/CreateFlight";
import EditProfile from "../main/body/screens/IAM/EditProfile/EditProfile";
import MedicalEmergencyCreate from "../main/body/screens/EMS/MedicalEmergencyCreate/MedicalEmergencyCreate";
import MedicalEmergencyHomeScreen from "../main/body/screens/MedicalEmergencyHomeScreen/MedicalEmergencyHomeScreen";
import Flights from "../main/body/screens/IAM/Flights/Flights";
import UserActivity from "../main/body/screens/IAM/UserActivity/UserActivity";
import Login from "../main/body/screens/Login/Login";
import MedicalKit from "../main/body/screens/IAM/MedicalKit/MedicalKit";
import Passengers from "../main/body/screens/IAM/Passengers/Passengers";
import AddPassengers from "../main/body/screens/IAM/Passengers/AddPassengers";
import EditPassengersDetails from "../main/body/screens/IAM/Passengers/EditPassengersDetails";
import PassengerDetails from "../main/body/screens/IAM/Passengers/PassengerDetails";
import OnlineForm from "../main/body/screens/OnlineForm/OnlineForm";
import OnlineFormList from "../main/body/screens/OnlineForm/OnlineFormList";
import ViewDetailedForm from "../main/body/screens/OnlineForm/ViewDetailedForm";
import MedicalEventReportForm from "../main/body/screens/OnlineForm/MedicalEventReportForm";
import MedicalEventReportFormList from "../main/body/screens/OnlineForm/MedicalEventReportFormList";
import FitToFly from "../main/body/screens/OnlineForm/FitToFly";
import AddFitToFly  from "../main/body/screens/OnlineForm/AddFitToFly ";
import FitToFlyflow from "../main/body/screens/OnlineForm/FitToFlyflow";
import FitToFlyView from "../main/body/screens/OnlineForm/FitToFlyView";
import RouteGuard from "../RouteGuard"; // Import the guard
// ... (keep all your other imports)

function Router(): JSX.Element {
  return ( 
    <Routes>
      {/* Public routes (no protection needed) */}
      <Route path="/" element={<LoadingScreen />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      {/* Protected routes (wrapped with RouteGuard) */}
      <Route element={<RouteGuard />}>
        {/* Common routes */}
        <Route path="/home" element={<HomeScreen />} />
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/users/profile" element={<Profile />} />
        
        {/* EMS-specific routes */}
        <Route
          path="medical-emergencies"
          element={<MedicalEmergencyHomeScreen />}
        >
          <Route path="" element={<MedicalEmergencyListScreen />} />
          <Route
            path="emergency/:medicalEmergencyId"
            element={<MedicalEmergencyDetails />}
          />
        </Route>

        <Route
          path="ems/medical-emergencies"
          element={<MedicalEmergenciesMainScreen />}
        >
          <Route path="" element={<MedicalEmergencyListScreen />} />
          <Route path="history" element={<MedicalEmergencyHistory />} />
          <Route path="initiate-medical" element={<MedicalEmergencyCreate />} />
          <Route
            path="emergency/:medicalEmergencyId"
            element={<MedicalEmergencyDetails />}
          />
          <Route
            path="history/emergency/:medicalEmergencyId"
            element={<MedicalEmergencyDetails />}
          />
        </Route>

        {/* Admin/SuperAdmin routes */}
        <Route path="flights" element={<Flights />} />
        <Route path="medicalkit" element={<MedicalKit />} />
        <Route path="users" element={<Users />} />
        <Route path="create-user" element={<CreateUsers />} />
        <Route path="passengers" element={<Passengers/>}/>
        <Route path="passengers/addPassengers" element={<AddPassengers/>}/>
        <Route path="/passenger-details/:passengerId" element={<PassengerDetails />} />
        <Route path="/fittofly-view/:passengerId" element={<FitToFlyView  />} />

        {/* SuperAdmin-only routes */}
        <Route path="roles" element={<Roles />} />
        <Route path="create-role" element={<CreateRole />} />
        <Route path="organization" element={<Organization/>}/>
        <Route path="AddSubscription" element={<AddSubscription/>}/>
        <Route path="ViewSubscription" element={<ViewSubscription/>}/>
        <Route path="user-activity" element={<UserActivity />} />
        <Route path="submittedforms" element={<OnlineFormList/>} />
        
        {/* Form routes */}
        <Route path="onboardingGuide" element={<OnlineForm />} />
        
        <Route path="verifyForm/:formId" element={<ViewDetailedForm /> } />
        <Route path="medicalEventReportForm/:eventId" element={<MedicalEventReportForm /> } />
        <Route path="medicalEventReportFormList" element={<MedicalEventReportFormList />} />
        <Route path="FitToFly" element={<FitToFly />} />
        <Route path="FitToFlyflow" element={<FitToFlyflow />} />
        <Route path="AddFitToFly" element={<AddFitToFly />} />

        {/* Coordinator Route */}
        <Route path="coordinator" element={<CoordinatorHome />} />
        <Route path="call/:medicalEmergencyId/:videoCall" element={<AudioConference />} />
        <Route path="*" element={
          <div className='skali-home-page'>
            <div className='row'>
                <div className='w-100'>
                    <h1 style={{color:'#FFFFFF', textAlign:'center'}}>Page not found</h1>
                </div>
            </div>
        </div>
        } />
      </Route>
      <Route path="*" element={
        <div className='skali-home-page'>
          <div className='row'>
              <div className='w-100'>
                  <h1 style={{color:'#FFFFFF', textAlign:'center'}}>Page not found</h1>
              </div>
          </div>
      </div>
      } />
    </Routes>
  );
}

export default Router;